import { render, staticRenderFns } from "./sky-img-rotate.vue?vue&type=template&id=dfb33aee"
import script from "./sky-img-rotate.vue?vue&type=script&lang=js"
export * from "./sky-img-rotate.vue?vue&type=script&lang=js"
import style0 from "./sky-img-rotate.vue?vue&type=style&index=0&id=dfb33aee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports